

export const fromDotNetDate = (s) => {
  if (typeof s === 'string') {
    const m = s.match(/\/Date\((\d+)\)\//)
    if (m !== null) {
      return new Date(parseInt(m[1]))
    }
  }

  return null
}
